import { getOptions } from 'components/common/InputSelect/inputSelect.utils';
import { IsMainContactOwnerOption } from 'components/prequalification/EntryForm/entryForm.enums';
import { MainContactPositionForEntryForm } from 'components/prequalification/prequalification.enums';

export const IS_MAIN_CONTACT_OWNER_SELECT_OPTIONS = getOptions(IsMainContactOwnerOption);
export const MAIN_CONTACT_POSITION_SELECT_OPTIONS = getOptions(MainContactPositionForEntryForm);
